module.exports = __webpack_public_path__ + "static/media/facebook.617ee512.svg";